import router from '@/router'

import { getItem } from '@/api/defaultApi'
import switchCreateOrUpdate from '@/utils/store/switchCreateOrUpdate'
import { LOGISTIC_OBJECT_URL } from '@/api/Logistic'

const initialState = () => {
  return {
    urlApi: LOGISTIC_OBJECT_URL,
    id: null,
    object: {
      name: '',
      code: '',
      master: '',
      comment: ''
    },
    validation: {
      name: {
        type: null,
        message: ''
      },
      code: {
        type: null,
        message: ''
      }
    },
    isLoading: true
  }
}

const state = initialState

const getters = {
  getObjectItem: state => state.object,
  getObjectItemValidation: state => state.validation,
  getObjectItemIsLoading: state => state.isLoading
}

const mutations = {
  SET_OBJECT_INITIAL_STATE: (state) => {
    Object.assign(state, initialState())
  },

  SET_OBJECT_ITEM: (state, object) => {
    state.object = {
      name: object.name,
      code: object.code,
      master: object.master,
      comment: object.comment
    }
    state.id = object.id
  },

  SET_OBJECT_ITEM_IS_LOADING: (state) => {
    state.isLoading = true
  },

  SET_OBJECT_ITEM_NAME: (state, value) => {
    state.object.name = value
  },

  SET_OBJECT_ITEM_CODE: (state, value) => {
    state.object.code = value
  },

  SET_OBJECT_ITEM_MASTER: (state, value) => {
    state.object.master = value
  },

  SET_OBJECT_ITEM_COMMENT: (state, value) => {
    state.object.comment = value
  },

  SET_OBJECT_ITEM_VALIDATION: (state, valid) => {
    if (valid.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
    if (valid.code) {
      state.validation.code.message = valid.code[0]
      state.validation.code.type = 'error'
    }
  },

  CLEAR_OBJECT_ITEM_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.validation.name = {
          type: null,
          message: ''
        }
        break
      case 'code':
        state.validation.code = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  }
}

const actions = {
  getObjectItem ({ commit, state }, id) {
    commit('SET_OBJECT_ITEM_IS_LOADING')
    getItem(state.urlApi, id)
      .then(response => {
        commit('SET_OBJECT_ITEM', response.data.data)
        state.isLoading = false
      })
      .catch(error => {
        console.log('ошибка получения объекта', error.response)
      })
  },

  saveObjectItem ({ commit, state }) {
    switchCreateOrUpdate(state.urlApi, state.id, state.object)
      .then(() => {
        router.push({ name: 'LogisticObjectList' })
      }).catch(error => {
        commit('SET_OBJECT_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления объекта', error.response)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
